import { useEffect, useMemo, useState } from 'react';

import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import { Button, CustomInput, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import moment from 'moment';
import Select from "react-select";
import CustomSelectInput from "../../../../components/common/CustomSelectInput";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from 'react-redux';
import { NotificationManager } from "../../../../components/common/react-notifications";
import { ORDER_COLLECTION } from '../../../../config/env';
import { firestore, functions } from '../../../../helpers/Firebase';
import { accessTypesObject, deepCompareArray } from '../../../../helpers/Utils';
import { DISCOUNT_FIELDS, applyCarriedDiscounts, loadDiscountContext, resolveCarriedDiscounts } from '../../../../helpers/reassignDiscounts';
import { buildVatSnapshot, exclusiveVatOnTop, extractInclusiveVat } from '../../../../helpers/pricing';
import AddCar from './AddCar';
import DetailsTable from './receipt';

const statusOptions = [
  { label: 'Pending', value: 'new', key: 'new' },
  { label: 'Accepted', value: 'accepted', key: 'accepted' },
  { label: 'Active', value: 'active', key: 'active' },
  { label: 'Completed', value: 'completed', key: 'completed' },
  { label: 'Rejected', value: 'rejected', key: 'rejected' },
  { label: 'Canceled', value: 'canceled', key: 'canceled' },
]

const cancelReasons = [
  'Service Provider Delay',
  'Service Provider Vehicle Issues',
  'Service Provider Unresponsive',
  'Customer Unavailable',
  'Other'
];

const DISCOUNT_LABELS = {
  promo: 'Promo code', promoReward: 'Promo code reward (voucher / BOGO on completion)', voucher: 'Wallet voucher',
  bogo: 'BOGO', points: 'Loyalty points', credit: 'Wallet credit',
}
const DROP_REASONS = {
  promoNotValidForNewProvider: 'not valid for the new provider / service',
  promoOfferNotFound: 'promo code no longer exists',
  unknownDiscount: 'unknown discount source',
  bogoNotValidForNewProvider: 'not valid for the new provider / service',
  bogoRecordNotFound: 'BOGO record not found',
  belowVoucherMinAmount: "new price is below the voucher's minimum",
  exceedsNewPrice: 'more than the new price',
}
// Manage Order provider / worker dropdowns: why a provider or worker cannot take this order
// (reasons come from functions/reassign/matcher.js evaluateProvidersForAdmin).
const NOT_ELIGIBLE_REASONS = {
  outOfArea: "Doesn't serve this address",
  serviceNotOffered: "Doesn't offer this service",
  vehicleCategoryNotOffered: "Doesn't serve this vehicle type",
  towTypeNotOffered: "No truck for this tow type",
  washingTypeNotOffered: "Doesn't offer this wash type",
  variationNotOffered: "Doesn't offer the selected option",
  unknownVehicleCategory: 'Unknown vehicle category',
  durationMissing: 'Service duration not set',
  noVehicles: 'No vehicles on this order',
  noActiveWorkers: 'No active workers',
  inactive: 'Inactive provider',
}
const ORDER_CLOSED_STATUSES = ['completed', 'rated', 'notRated']
const formatEligibilityOption = (option, { context }) => (context === 'menu' && option._info
  ? <div>
    <div>{option.label}{option._current ? ' (current)' : ''}</div>
    <small style={{ opacity: 0.7 }}>{option._info}</small>
  </div>
  : option.label)

const pickDiscountFields = (price) => DISCOUNT_FIELDS.reduce((out, k) => {
  if (price?.[k] !== undefined) out[k] = price[k]
  return out
}, {})

const DatepickerInput = ({ ...props }) => (
  <input type="text" {...props} readOnly />
);
const ManageOrder = ({ selectedBooking, washers, providers, manageOrder, modifiers, bookings, services, dismiss, updateAppointment }) => {
  const [confirmUpdate, setConfirmUpdate] = useState(false)
  const [reassignmentChoice, setReassignmentChoice] = useState(null)
  const [addCar, setAddCar] = useState(false)
  const [recoveryErrorModal, setRecoveryErrorModal] = useState(false)
  const [recoveryErrorMessage, setRecoveryErrorMessage] = useState('')
  const [isUpdating, setIsUpdating] = useState(false)
  const [isCompletingCash, setIsCompletingCash] = useState(false)
  // Completing a towing order: how the customer paid. No default — support must choose, so the
  // saved card is never charged for an order already paid by payment link or cash.
  const [recoveryPaidBy, setRecoveryPaidBy] = useState(null)   // 'card' | 'paymentLink' | 'cash'
  const [recoveryPaidAmount, setRecoveryPaidAmount] = useState('')
  const [recoveryPaidRef, setRecoveryPaidRef] = useState('')
  // Charging the card on a cancelled / rejected order needs an explicit confirmation (the server checks it too).
  const [confirmChargeCanceled, setConfirmChargeCanceled] = useState(false)
  const recoveryOrderCanceled = ['canceled', 'rejected'].includes(selectedBooking?.status)
  const { user } = useSelector(state => state.authUser)

  const [newOrder, setNewOrder] = useState(JSON.parse(JSON.stringify(selectedBooking)))
  const [status, setStatus] = useState(false)
  const [service, setService] = useState({})
  const [orderDate, setOrderDate] = useState(false)
  const [washer, setWasher] = useState(false)
  const [provider, setProvider] = useState({})
  const [filteredWashers, setFilteredWashers] = useState([])
  const [price, setPrice] = useState(0)
  const [duration, setDuration] = useState(0)
  const [onlinePayment, setOnlinePayment] = useState(selectedBooking?.price?.collectOutstandingOnline || false)
  // Completing a towing order changes provider / worker on the same booking (the job is done), so the
  // reassignment flow (new booking, payment carry-over) doesn't apply.
  const completingTowing = status === 'completed' && selectedBooking?.status !== 'completed' && !!selectedBooking?.recoveryInfo
  // Sent with the completion so the server saves them before charging (VAT follows the provider).
  const towingAssignment = {
    ...(provider?.key && provider.key !== selectedBooking?.sp_id ? { sp_id: provider.key } : {}),
    ...(washer?.key && washer.key !== selectedBooking?.washer_id ? { washer_id: washer.key } : {}),
  }

  const [car, UpdateCars] = useState(newOrder.carDetail);
  const [addonsOptimized, setAddons] = useState({})

  // The original's promo offer / wallet voucher / wallet BOGO, so a reassignment can tell which
  // discounts are still valid at the new provider (helpers/reassignDiscounts.js).
  const [discountContext, setDiscountContext] = useState(null)
  const [carriedDiscounts, setCarriedDiscounts] = useState(null)

  // Which providers / workers can take this order (active, same service + vehicle + wash type,
  // serving the address). While loading or on error the dropdowns fall back to everyone.
  const [spOptions, setSpOptions] = useState({ loading: false, error: false, byId: null })
  const [showAllProviders, setShowAllProviders] = useState(false)
  useEffect(() => {
    if (!selectedBooking?.key || ORDER_CLOSED_STATUSES.includes(selectedBooking?.status)) return
    let alive = true
    setSpOptions({ loading: true, error: false, byId: null })
    functions().httpsCallable('reassignAdminProviderOptions')({ bookingId: selectedBooking.key })
      .then(res => {
        if (!alive) return
        const byId = {}
        ;(res?.data?.providers || []).forEach((p, i) => { byId[p.sp_id] = { ...p, order: i } })
        setSpOptions({ loading: false, error: false, byId })
      })
      .catch(error => {
        console.log('reassignAdminProviderOptions', error)
        if (alive) setSpOptions({ loading: false, error: true, byId: null })
      })
    return () => { alive = false }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBooking?.key])

  // One line under each provider / worker: the exact total the order details will show after the
  // pick, distance, and what happens to the booked time.
  const optionInfo = useMemo(() => {
    const currentTotal = Number(selectedBooking?.price?.totalPrice || 0)
    const unpaid = Number(selectedBooking?.price?.previousUnpaidAmount || 0)
    const bookedTime = selectedBooking?.bookingTime?.startTime ? moment(selectedBooking.bookingTime.startTime).format('hh:mm A') : ''
    // bookingDate carries the day, bookingTime.startTime the time of day (1955 convention)
    const bookedAt = selectedBooking?.bookingDate && selectedBooking?.bookingTime?.startTime
      ? moment(selectedBooking.bookingDate).set({ hour: moment(selectedBooking.bookingTime.startTime).hour(), minute: moment(selectedBooking.bookingTime.startTime).minute(), second: 0 })
      : null
    const bookedPassed = !!bookedAt && bookedAt.isBefore(moment())
    // Picking another provider drops add-ons / variation / warranty / pickup (provider onChange),
    // so the price effect computes: service price − discounts that carry + unpaid balance.
    const totalFor = (spId, servicePrice) => {
      const carried = resolveCarriedDiscounts(selectedBooking?.price, discountContext || {}, {
        spId, serviceId: selectedBooking?.service_id, washingType: selectedBooking?.washingType,
        grossPrice: Number(servicePrice), promoBase: Number(servicePrice),
      })
      return Number(servicePrice) - carried.discount + unpaid
    }
    const slotText = (slot) => {
      if (!slot) return `No free time on the booked day${bookedTime ? ` (booked ${bookedTime})` : ''}`
      if (slot.deltaMinutes === 0) return `Booked time ${bookedTime} available`
      return `Booked time ${bookedTime} ${bookedPassed ? 'has passed' : 'not available'} · moves to ${moment(slot.startMs).format('hh:mm A')}`
    }
    return (spId, o) => {
      if (!o) return ''
      if (!o.eligible) return NOT_ELIGIBLE_REASONS[o.reason] || o.reason || 'Not eligible'
      // Towing keeps the original price and time; there is no slot search.
      if (selectedBooking?.recoveryInfo) return 'Same towing price'
      const parts = []
      if (spId !== selectedBooking?.sp_id && o.servicePrice != null) {
        const total = totalFor(spId, o.servicePrice)
        const delta = Number((total - currentTotal).toFixed(2))
        // difference from what the customer pays now: (+5.00 AED) dearer, (-5.00 AED) cheaper
        parts.push(`${total.toFixed(2)} AED${delta ? ` (${delta > 0 ? '+' : '-'}${Math.abs(delta).toFixed(2)} AED)` : ' (same price)'}`)
      }
      if (o.distanceKm != null) parts.push(`${o.distanceKm} km`)
      parts.push(slotText(o.nearestSlot))
      return parts.join(' · ')
    }
  }, [selectedBooking, discountContext])

  // Reassigning: picking a provider (or one of its workers) applies that worker's free time —
  // the booked time when it is free, else the nearest free time that day.
  const applyWorkerSlot = (spId, washerKey) => {
    const info = spOptions.byId?.[spId]?.workers?.find(w => w.washer_id === washerKey)
    const slot = info?.eligible && info?.nearestSlot
    if (!slot) return
    const start = moment(slot.startMs)
    setOrderDate(start.toDate())
    newOrder.bookingDate = start.valueOf()
    newOrder.bookingTime = newOrder.bookingTime || {}
    newOrder.bookingTime.startTime = moment("1955-01-05T" + start.format('HH:mm')).valueOf()
    newOrder.bookingTime.endTime = moment(newOrder.bookingTime.startTime).add(Number(info.durationMs || 0), 'ms').add(30, 'minutes').valueOf()
  }

  const providerOptions = useMemo(() => {
    const all = Object.values(providers || {}).filter(p => p?.name && String(p.name).trim())
    const byId = spOptions.byId
    if (!byId) return all
    const decorate = (p, o) => ({
      ...p,
      _current: p.key === selectedBooking?.sp_id,
      _info: o ? optionInfo(p.key, o) : NOT_ELIGIBLE_REASONS.inactive,
      isDisabled: !(o?.eligible) && p.key !== selectedBooking?.sp_id,
    })
    const known = all.filter(p => byId[p.key]).sort((a, b) => byId[a.key].order - byId[b.key].order)
    const eligible = known.filter(p => byId[p.key].eligible || p.key === selectedBooking?.sp_id).map(p => decorate(p, byId[p.key]))
    if (!showAllProviders) return eligible
    const notEligible = known.filter(p => !byId[p.key].eligible && p.key !== selectedBooking?.sp_id).map(p => decorate(p, byId[p.key]))
    const inactive = all.filter(p => !byId[p.key] && p.key !== selectedBooking?.sp_id).map(p => decorate(p, null))
    return [...eligible, ...notEligible, ...inactive]
  }, [providers, spOptions.byId, showAllProviders, selectedBooking?.sp_id, optionInfo])

  const workerOptions = useMemo(() => {
    const spInfo = spOptions.byId?.[provider?.key]
    if (!spInfo) return filteredWashers
    const byWorker = {}
    spInfo.workers.forEach(w => { byWorker[w.washer_id] = w })
    const decorate = (w) => ({
      ...w,
      _info: byWorker[w.key] ? optionInfo(provider?.key, byWorker[w.key]) : 'Inactive worker',
      isDisabled: !(byWorker[w.key]?.eligible) && w.key !== selectedBooking?.washer_id,
    })
    const ok = filteredWashers.filter(w => byWorker[w.key]?.eligible || w.key === selectedBooking?.washer_id).map(decorate)
    if (!showAllProviders) return ok
    return [...ok, ...filteredWashers.filter(w => !(byWorker[w.key]?.eligible) && w.key !== selectedBooking?.washer_id).map(decorate)]
  }, [filteredWashers, spOptions.byId, provider?.key, showAllProviders, selectedBooking?.washer_id, optionInfo])
  useEffect(() => {
    let alive = true
    loadDiscountContext(firestore(), selectedBooking).then(ctx => { if (alive) setDiscountContext(ctx) })
    return () => { alive = false }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBooking?.key])

  // Reassignment math, shared between updateOrder, the confirm-modal info
  // block, and the Apply-button disabled gate. Chained reassignments
  // (B→C where B was already reassigned from A) must use the original card
  // capture, not B's inflated totalPrice — so we inherit `prePaid` if set.
  const reassignmentMath = useMemo(() => {
    const isOriginalOnlinePaid = !!selectedBooking?.refundable
    const oldTotal = Number(selectedBooking?.price?.totalPrice || 0)
    const newTotal = Number(newOrder?.price?.totalPrice || 0)
    const cardCaptured = Number(selectedBooking?.price?.prePaid) > 0
      ? Number(selectedBooking.price.prePaid)
      : oldTotal
    const previousWaived = Number(selectedBooking?.price?.reassignmentWaived) || 0
    const previousWaivedBy = selectedBooking?.price?.reassignmentWaivedBy
    const effectiveOldPaid = cardCaptured + previousWaived
    const effectiveDelta = Number((newTotal - effectiveOldPaid).toFixed(2))
    return { isOriginalOnlinePaid, oldTotal, newTotal, cardCaptured, previousWaived, previousWaivedBy, effectiveOldPaid, effectiveDelta }
  }, [selectedBooking, newOrder?.price?.totalPrice])


  const createNotification = (className, msg) => {
    let cName = className || "";
    return (
      NotificationManager.error(
        msg,
        "Error",
        2000,
        null,
        cName
      )
    )
  };
  useEffect(() => {
    setProvider(Object.values(providers).find(rec => rec.key === newOrder?.sp_id))
    setWasher(Object.values(washers).find(rec => rec.key === newOrder?.washer_id) || false)
    setService(Object.values(services).find(rec => rec.key === newOrder?.service_id))
    setStatus(newOrder.status)
    setOrderDate(new Date(newOrder?.bookingDate))
    setNewOrder(newOrder)



    if (newOrder.addons) {
      let addons = newOrder.addons?.reduce((cars, currentAddon) => {
        if (currentAddon.cars) {
          Object.keys(currentAddon.cars).map(carKey => {
            let car = currentAddon.cars[carKey]
            if (cars[car.car_model]) {
              cars[car.car_model][currentAddon.id] = { name: currentAddon.name, type: currentAddon.type, price: car.price, category: car.category, count: car.count }
              return cars
            } else {
              cars[car.car_model] = { [currentAddon.id]: { name: currentAddon.name, type: currentAddon.type, price: car.price, category: car.category, count: car.count } }
              return cars
            }
          })
        }
        return cars
      }, {})
      setAddons(addons)
    }
  }, [newOrder, providers, washers, services])


  useEffect(() => {
    setFilteredWashers(Object.values(washers).filter(rec => rec?.sp_id === provider?.key))
  }, [washers, provider])

  useEffect(() => {
    let price = 0
    let durationMin = 0
    let carried = null

    if (car.length && !newOrder?.recoveryInfo) {
      let variationPrice = 0
      let warrantyPrice = 0
      let pickupAndDropoffPrice = 0
      let pickupOnlyPrice = 0
      car.forEach(rec => {
        let id = Object.values(modifiers).find(record => record?.name === rec?.modelNumber?.category)?.key
        let modifierDuration = newOrder?.washingType === 'waterlessWash' ? washer?.activeServices?.[service?.key]?.[id]?.waterlessDuration : newOrder?.washingType === 'steamWash' ? washer?.activeServices?.[service?.key]?.[id]?.steamWashDuration : washer?.activeServices?.[service?.key]?.[id]?.duration

        if (modifierDuration) {
          const hours = modifierDuration.split(':')[0];
          const minutes = modifierDuration.split(':')[1];
          durationMin = durationMin + (parseInt(hours) * 60) + (parseInt(minutes));
        }
        // price = price + (Number(washer?.activeServices?.[service?.key]?.[id]?.price || 0) * 1)

        if (newOrder?.recoveryInfo) {
          price = price + (Number(selectedBooking?.price?.subTotal || 0) * 1)
        } else {
          price = price + ((newOrder?.washingType === 'waterlessWash' ?
            Number(washer?.activeServices?.[service?.key]?.[id]?.waterlessPrice || 0)
            : newOrder?.washingType === 'steamWash' ?
              Number(washer?.activeServices?.[service?.key]?.[id]?.steamWashPrice || 0)
              : Number(washer?.activeServices?.[service?.key]?.[id]?.price || 0)) * 1)
        }


        // eslint-disable-next-line
        if (newOrder?.variation) {
          let variPrice = newOrder?.price?.variPrice?.[id] || 0
          variationPrice = variationPrice + variPrice
          newOrder.price.variationPrice = variationPrice || 0

          warrantyPrice = Number(newOrder?.price?.warrantyPrice || 0)
          pickupAndDropoffPrice = Number(newOrder?.price?.pickupAndDropoffPrice || 0)
          pickupOnlyPrice = Number(newOrder?.price?.pickupOnlyPrice || 0)
        }


        // price.variationPrice = variationPrice
        let addonsPrice = newOrder?.addons?.reduce((total, currentValue) => {
          let cumPrice = 0
          Object.values(currentValue.cars).map(item => {
            return (cumPrice += Number(item?.price || 0) * Number(item?.count || 0))
          })
          return ((total) + cumPrice)
        }, 0)
        newOrder.price.addonsPrice = addonsPrice || 0
        newOrder.price.servicePrice = price || 0
        newOrder.price.previousUnpaidAmount = Number(selectedBooking?.price?.previousUnpaidAmount || 0)

        // Reassignment: re-decide which of the original's discounts still apply at the new provider
        // (provider-scoped promo codes / BOGO drop; loyalty points, wallet credit and vouchers carry).
        if (provider?.key && selectedBooking?.sp_id && provider.key !== selectedBooking.sp_id) {
          carried = resolveCarriedDiscounts(selectedBooking?.price, discountContext || {}, {
            spId: provider.key,
            serviceId: newOrder?.service_id,
            washingType: newOrder?.washingType,
            grossPrice: Number(price || 0) + Number(newOrder?.price?.addonsPrice || 0) + Number(newOrder?.price?.variationPrice || 0) + warrantyPrice + pickupAndDropoffPrice + pickupOnlyPrice,
            promoBase: Number(price || 0) + Number(newOrder?.price?.addonsPrice || 0) + Number(newOrder?.price?.variationPrice || 0),
          })
          applyCarriedDiscounts(newOrder.price, carried)
        }

        // VAT — same rules as the customer app checkout: 5% on service + add-ons, computed before
        // discounts (a discount never reduces VAT); exclusive-priced SPs add it on top. A discount
        // covering the whole discountable price also covers its VAT.
        const discountable = Number(price || 0) + Number(newOrder?.price?.addonsPrice || 0) + Number(newOrder?.price?.variationPrice || 0)
        const vatBase = Number(price || 0) + Number(newOrder?.price?.addonsPrice || 0)
        // Only price VAT in when the booking was already priced with VAT (snapshot on the booking),
        // or it's being moved to another SP. Old app builds (<= 11.30) booked VAT SPs without
        // charging VAT; re-pricing those here would change the total and flip the order to cash,
        // voiding the customer's card payment.
        const sameSp = !provider?.key || provider.key === selectedBooking?.sp_id
        const applyVat = !!provider?.vatRegistered && (!sameSp || !!selectedBooking?.price?.vatRegistered)
        const vatOnTop = applyVat && !provider?.pricesIncludeVat
        const vat = !applyVat ? 0 : (provider?.pricesIncludeVat ? extractInclusiveVat(vatBase) : exclusiveVatOnTop(vatBase))
        const discount = Number(newOrder?.price?.discount || 0)
        const discountedLines = vatOnTop && discount >= discountable - 0.005
          ? 0
          : discountable + (vatOnTop ? vat : 0) - discount
        const extras = warrantyPrice + pickupAndDropoffPrice + pickupOnlyPrice
        const unpaid = Number(newOrder?.price?.previousUnpaidAmount || 0)
        if (applyVat || !sameSp) Object.assign(newOrder.price, buildVatSnapshot(provider, vat))
        newOrder.price.totalPrice = Number((discountedLines + extras + unpaid).toFixed(2))
        newOrder.price.services = washer?.activeServices?.[service?.key]
        newOrder.price.subTotal = newOrder.price.totalPrice
        newOrder.totalPrice = Number((discountable + (vatOnTop ? vat : 0) + extras + unpaid).toFixed(2))
        if ((!deepCompareArray(newOrder?.carDetail, car) || selectedBooking?.price?.outstanding)) {
          newOrder.price.outstanding = Number(selectedBooking?.price?.outstanding || 0) + Number(newOrder?.price?.totalPrice) - Number(selectedBooking?.price?.totalPrice)
        }
        setNewOrder(newOrder)
        setPrice(price)
        setDuration(durationMin)
      })
      setCarriedDiscounts(carried)
    } else {
      setNewOrder(newOrder)
      setPrice(selectedBooking?.price?.subTotal || 0)
      setDuration(0)
      setCarriedDiscounts(null)
    }
    // eslint-disable-next-line
  }, [car, service, washer, modifiers, newOrder, selectedBooking, provider, discountContext])
  function removeCar(addons, carModel) {
    // eslint-disable-next-line
    addons.map((addon, i) => {
      const cars = addon?.cars;
      if (cars?.[carModel]) {
        delete cars[carModel];
        if (Object.keys(cars).length === 0) {
          addons.splice(i, 1);
        }
      }
      if (Object.keys(addon?.cars || {}).length === 0) {
        addons.splice(i, 1);
      }
    })
    return addons
  }
  const _getReservedSlot = (washer) => {
    if (washer) {
      const slots = [];
      Object.values(bookings).map(rec => {
        let { bookingDate, bookingTime } = rec
        if (['new', 'accepted', 'active'].includes(rec.status) && washer.key === rec.washer_id && moment(bookingDate).isAfter(moment())) {
          let duration = moment.duration(moment(bookingTime.endTime).diff(moment(bookingTime.startTime))).asMinutes();
          let reservedSlot = bookingDate;
          while (moment(reservedSlot).isBefore(moment(bookingDate).add(duration, 'minutes'))) {
            slots.push({ reservedSlot, bookingTime })
            reservedSlot = moment(reservedSlot).add(15, 'minutes').valueOf()
          }
        }
        return rec
      })
      return slots
    }
  };
  const _filterPassedTime = () => {
    let today = moment(orderDate || new Date()).format('dddd')

    const availableTime =
      (washer?.timings?.[today]?.isOpen &&
        washer?.timings?.[today]?.timings) ||
      [];
    const slots = [];
    availableTime.map(item => {


      let startTime = moment(item.startTime)
        .set('year', moment(orderDate).year())
        .set('month', moment(orderDate).month())
        .set('date', moment(orderDate).date()).seconds(0).milliseconds(0);
      let endTime = moment(item.endTime)
        .set('year', moment(orderDate).year())
        .set('month', moment(orderDate).month())
        .set('date', moment(orderDate).date()).seconds(0).milliseconds(0);


      let slot = startTime.valueOf();
      while (moment(slot).isBefore(endTime)) {
        slots.push(slot)
        slot = moment(slot).add(15, 'minutes').valueOf()
      }
      return item
    })

    let filterSlots = slots.filter(rec => !moment(rec).isSame(moment(washer?.busyTimings?.startTime)) && !moment(rec).isBetween(moment(washer?.busyTimings?.startTime), moment(washer?.busyTimings?.endTime)))

    return filterSlots
  };

  const updateOrder = async () => {
    setIsUpdating(true);

    const newItem = {
      canceledBy: newOrder.canceledBy || (newOrder.status === 'canceled' || newOrder.status === 'rejected' ? 'Super Admin' : ''),
      addons: newOrder.addons || [],
      bookingDate: newOrder.bookingDate,
      bookingTime: newOrder.bookingTime,

      updated: Date.now(),

      sp_id: provider?.key,
      sp_name: provider?.name,

      status: status,

      washer_id: washer?.key,
      washer_name: washer?.name,

      paymentMethod: Number(newOrder?.price?.totalPrice).toFixed(2) !== Number(selectedBooking?.price?.totalPrice).toFixed(2) ? {
        ...selectedBooking.paymentMethod,
        amount: newOrder?.price?.totalPrice,
        currency: "AED"
      } : selectedBooking.paymentMethod,
      paymentType: Number(newOrder?.price?.totalPrice).toFixed(2) !== Number(selectedBooking?.price?.totalPrice).toFixed(2) ? 'cash' : selectedBooking.paymentType,

      price: newOrder.price,
      totalPrice: newOrder.price.totalPrice,
    };
    if (newOrder?.cancelReason) {
      newItem.cancelReason = newOrder.cancelReason
    }
    if (newOrder?.cancellationApplied) {
      newItem.cancellationApplied = newOrder?.cancellationApplied || false
    }
    if (onlinePayment) {
      newItem.price.collectOutstandingOnline = onlinePayment
    }
    // Always set isUnpaid from newOrder to ensure it's defined
    // Only update if it's explicitly changed from unpaid to paid
    if (newOrder.isUnpaid !== undefined) {
      newItem.isUnpaid = newOrder.isUnpaid
    } else {
      // If not explicitly set in newOrder, keep the original value
      newItem.isUnpaid = selectedBooking.isUnpaid
    }
    if (!deepCompareArray(newOrder?.carDetail, car)) {
      newItem.carDetail = car
    }

    if (selectedBooking.bookingDate !== newOrder.bookingDate) {
      newItem.adminReschedule = Date.now()
      let customer = await firestore().collection('users').doc(selectedBooking?.customer_id).get()
      if (customer?.data()?.fcm_token) {
        firestore().collection('notifications').add({
          user: selectedBooking?.customer_id,
          to: customer?.data()?.fcm_token,
          title: "Appointment Rescheduled ",
          body: `Your appointment has been rescheduled from ${moment(selectedBooking.bookingDate).format('DD/MM/YYYY hh:mm A')} to ${moment(newOrder.bookingDate).format('DD/MM/YYYY hh:mm A')}`,
          read: false,
        })
      }

    }
    let logs = [
      selectedBooking.sp_id !== provider.key && {
        title: 'reAssignProvider',
        created: Date.now(),
        oldProviderName: selectedBooking.sp_name,
        oldProviderId: selectedBooking.sp_id,
        provider_name: provider.name,
        provider_id: provider.key,
        createdBy: accessTypesObject?.[user?.accessType].name,
        createdByName: user?.displayName
      },
      selectedBooking.washer_id !== washer.key && {
        title: 'reAssignWorker',
        created: Date.now(),
        oldWasherName: selectedBooking.washer_name,
        oldWasherId: selectedBooking.washer_id,
        washer_name: washer.name,
        washer_id: washer.key,
        createdBy: accessTypesObject?.[user?.accessType].name,
        createdByName: user?.displayName
      },
      selectedBooking.bookingDate !== newOrder.bookingDate && {
        title: 'rescheduleDate',
        created: Date.now(),
        oldBookingDate: selectedBooking.bookingDate,
        bookingDate: newOrder.bookingDate,
        createdBy: accessTypesObject?.[user?.accessType].name,
        createdByName: user?.displayName
      },
      selectedBooking.status !== status && {
        title: status === 'canceled' ? "canceledAppointment" : status === 'rejected' ? "rejectedAppointment" : 'statusChanged',
        created: Date.now(),
        oldsStatus: selectedBooking.status,
        status: status,
        createdBy: accessTypesObject?.[user?.accessType].name,
        createdByName: user?.displayName
      },
      !deepCompareArray(selectedBooking?.carDetail, car) && {
        title: 'vehicleModified',
        created: Date.now(),
        oldVehicle: selectedBooking?.carDetail,
        newVehicle: car,
        createdBy: accessTypesObject?.[user?.accessType].name,
        createdByName: user?.displayName
      },
      newItem.cancellationApplied && selectedBooking.cancellationApplied !== newItem.cancellationApplied && {
        title: 'cancellationFeesApplied',
        created: Date.now(),
        createdBy: accessTypesObject?.[user?.accessType].name,
        createdByName: user?.displayName
      },
      // Only log orderPaid if the order changed from unpaid (true) to paid (false)
      selectedBooking.isUnpaid === true && newItem.isUnpaid === false && {
        title: 'orderPaid',
        created: Date.now(),
        createdBy: accessTypesObject?.[user?.accessType].name,
        createdByName: user?.displayName
      },
      selectedBooking.isUnpaid === false && newItem.isUnpaid === true && {
        title: 'orderUnpaid',
        created: Date.now(),
        createdBy: accessTypesObject?.[user?.accessType].name,
        createdByName: user?.displayName
      }
    ].filter(rec => rec)

    // Towing order already paid by payment link or cash: complete it without charging the card.
    if (status === 'completed' && selectedBooking?.status !== 'completed' && selectedBooking?.recoveryInfo && ['paymentLink', 'cash'].includes(recoveryPaidBy)) {
      const ok = await markRecoveryPaid(recoveryPaidBy, recoveryPaidAmount, recoveryPaidRef)
      if (ok) {
        // No dashboard log entries: the server logs what it applied (provider / worker change,
        // recoveryMarkedPaid). Other form edits (date, vehicle…) are not applied when completing.
        updateAppointment()
        setConfirmUpdate(false)
      }
      setIsUpdating(false)
      return
    }

    // Handle recovery order completion
    if (status === 'completed' && selectedBooking?.status !== 'completed' && selectedBooking?.recoveryInfo) {
      try {
        let response = await functions().httpsCallable('CompleteRecoveryOrder')({
          booking_id: selectedBooking.key,
          ...(recoveryOrderCanceled && confirmChargeCanceled ? { confirmChargeCanceled: true } : {}),
          ...towingAssignment,
        });
        console.log('CompleteRecoveryOrder response:', response);

        if (response?.data?.status === 'error') {
          setRecoveryErrorMessage(response?.data?.message || "Error completing recovery order");
          setRecoveryErrorModal(true);
          setConfirmUpdate(false);
          setIsUpdating(false);
          return;
        } else {
          // Only the completion itself: the server logs the provider / worker change, and other form
          // edits (date, vehicle…) are not applied when completing a towing order.
          logs.filter(rec => rec.title === 'statusChanged').map(rec => {
            return firestore().collection('logs').doc(selectedBooking.key).set({
              data: firestore.FieldValue.arrayUnion(rec),
              updated: Date.now()
            }, { merge: true }).catch(error => error)
          })

          updateAppointment()
          setConfirmUpdate(false)
          setIsUpdating(false);
          NotificationManager.success("Recovery order completed successfully!", "Success", 2000);
          return;
        }
      } catch (error) {
        console.error("Error calling CompleteRecoveryOrder function:", error);
        setRecoveryErrorMessage("Failed to complete recovery order");
        setRecoveryErrorModal(true);
        setConfirmUpdate(false);
        setIsUpdating(false);
        return;
      }
    }

    if (Object.keys(selectedBooking)?.length > 0 && selectedBooking.sp_id !== provider.key) {
      let bookingKey = firestore().collection(ORDER_COLLECTION).doc().id

      newItem.key = bookingKey
      newItem.id = bookingKey
      newItem.bookingId = bookingKey

      newItem.created = Date.now()
      newItem.orderNumber = Math.floor(Math.random(new Date().getTime()) * 90000000) + 10000000
      let newBooking = { ...selectedBooking, ...newItem }
      delete newBooking.price.addonsPrice
      // Discounts were re-decided for the new provider by the price effect (carriedDiscounts).
      // The original's cancel gives every discount back; this booking redeems what it carries
      // in its own trigger run, so it must not look like an engine replacement.
      delete newBooking.replacementOf
      delete newBooking.reassignment
      delete newBooking.reassigning
      delete newBooking.reassignmentDroppedDiscounts
      if (carriedDiscounts?.dropped?.length) newBooking.reassignmentDroppedDiscounts = carriedDiscounts.dropped
      delete newBooking.cancelReason
      delete newBooking.canceledBy
      delete newBooking.superAdminComment
      // Broadcast orders (towing SOS, quick wash) list who may see / take them. The replacement
      // belongs to the picked provider and worker only — keeping the original's lists let another
      // provider's worker take it while sp_id stayed on the picked provider.
      if (selectedBooking.serviceProviders) newBooking.serviceProviders = [provider.key]
      if (selectedBooking.workers) newBooking.workers = washer?.key ? [washer.key] : []

      // Reassignment wallet-bridge: payment from the original booking carries
      // over to the new one instead of refunding to wallet and re-collecting.
      // `cardCaptured` is the truth about what's actually on the NI gateway;
      // for chained reassignments it comes from the previous booking's prePaid
      // (which preserved the original capture amount), not the inflated total.
      const { isOriginalOnlinePaid, newTotal, cardCaptured, previousWaived, previousWaivedBy, effectiveDelta } = reassignmentMath

      newBooking.reAssignedFrom = selectedBooking.key

      let cancelPatch = {
        status: 'canceled',
        canceledBy: user?.displayName + ` (${accessTypesObject?.[user?.accessType].name})`,
        updated: Date.now(),
        // also for cash bookings: the cancel trigger reads it to keep vouchers the replacement carries
        reAssignedTo: bookingKey
      }

      const applyCarriedWaived = () => {
        if (previousWaived > 0) {
          newBooking.price.reassignmentWaived = previousWaived
          if (previousWaivedBy) newBooking.price.reassignmentWaivedBy = previousWaivedBy
        }
      }

      if (isOriginalOnlinePaid) {
        if (effectiveDelta < 0) {
          newBooking.paidViaReassignment = true
          newBooking.paymentMethod = { ...selectedBooking.paymentMethod, amount: newTotal, currency: 'AED' }
          newBooking.paymentType = selectedBooking.paymentType
          newBooking.price.prePaid = Math.max(0, cardCaptured - Math.abs(effectiveDelta))
          applyCarriedWaived()
          cancelPatch.reAssignedTo = bookingKey
          cancelPatch.reassignmentRefundAmount = Math.abs(effectiveDelta)
        } else if (Math.abs(effectiveDelta) < 0.01) {
          newBooking.paidViaReassignment = true
          newBooking.paymentMethod = selectedBooking.paymentMethod
          newBooking.paymentType = selectedBooking.paymentType
          newBooking.price.prePaid = cardCaptured
          applyCarriedWaived()
          cancelPatch.reAssignedTo = bookingKey
        } else if (effectiveDelta > 0 && reassignmentChoice === 'waive') {
          newBooking.paidViaReassignment = true
          newBooking.paymentMethod = selectedBooking.paymentMethod
          newBooking.paymentType = selectedBooking.paymentType
          newBooking.price.prePaid = cardCaptured
          newBooking.price.reassignmentWaived = previousWaived + effectiveDelta
          newBooking.price.reassignmentWaivedBy = user?.displayName
          cancelPatch.reAssignedTo = bookingKey
        } else if (effectiveDelta > 0 && reassignmentChoice === 'cash') {
          newBooking.paidViaReassignment = true
          newBooking.paymentMethod = selectedBooking.paymentMethod
          newBooking.paymentType = selectedBooking.paymentType
          newBooking.price.prePaid = cardCaptured
          newBooking.price.cashDueOnCompletion = effectiveDelta
          applyCarriedWaived()
          cancelPatch.reAssignedTo = bookingKey
        }
      }

      firestore().collection(ORDER_COLLECTION).doc(bookingKey).set(newBooking).then(function () {

        firestore().collection('logs').doc(bookingKey).set({
          data: logs,
          updated: Date.now()
        }, { merge: true }).catch(error => error)

        firestore().collection(ORDER_COLLECTION).doc(selectedBooking.key).update(cancelPatch).then(function () {
          updateAppointment()
          setConfirmUpdate(false)
          setReassignmentChoice(null)
          setIsUpdating(false);
          firestore().collection('logs').doc(selectedBooking.key).set({
            data: firestore.FieldValue.arrayUnion(
              {
                title: "canceledAppointment",
                created: Date.now(),
                oldsStatus: selectedBooking.status,
                status: 'canceled',
                createdBy: accessTypesObject?.[user?.accessType].name,
                createdByName: user?.displayName
              }
            ),
            updated: Date.now()
          }, { merge: true }).catch(error => error)

        }).catch(function (error) {
          console.error("Error writing document: ", error);
          setIsUpdating(false);
        });
      }).catch(function (error) {
        console.error("Error writing document: ", error);
        setIsUpdating(false);
      });

    } else {
      firestore().collection(ORDER_COLLECTION).doc(selectedBooking.key).update(newItem).then(function () {
        updateAppointment()
        setConfirmUpdate(false)
        setIsUpdating(false);
        logs.map(rec => {
          return firestore().collection('logs').doc(selectedBooking.key).set({
            data: firestore.FieldValue.arrayUnion(rec),
            updated: Date.now()
          }, { merge: true }).catch(error => error)
        })
      }).catch(function (error) {
        console.error("Error writing document: ", error);
        setIsUpdating(false);
      });

    }
  };

  // Towing order paid outside the saved card: the server completes it without charging
  // (MarkRecoveryOrderPaid), under the same lock as the card charge.
  const markRecoveryPaid = async (method, amount, reference) => {
    try {
      const res = await functions().httpsCallable('MarkRecoveryOrderPaid')({
        booking_id: selectedBooking.key, method, amount: Number(amount), reference: reference || null,
        ...towingAssignment,
      })
      if (res?.data?.status === 'success') {
        NotificationManager.success(method === 'cash' ? 'Order completed as paid in cash.' : 'Order completed as paid by payment link.', 'Success', 3000)
        return true
      }
      // Long enough to read (the message says what was already paid and what to check).
      NotificationManager.error(res?.data?.message || 'Could not complete this order.', 'Order not completed', 10000)
    } catch (error) {
      console.error('MarkRecoveryOrderPaid', error)
      createNotification('error', 'Could not complete this order. Nothing was changed.')
    }
    return false
  }

  const completeOrderAsCash = async () => {
    setIsCompletingCash(true);
    const ok = await markRecoveryPaid('cash', newOrder?.price?.totalPrice)
    setIsCompletingCash(false);
    if (ok) {
      updateAppointment()
      setRecoveryErrorModal(false)
    }
  };

  return (
    <Modal
      isOpen={manageOrder}
      backdrop="static"
      size="lg">
      <ModalHeader >{"Manage Order"}</ModalHeader>
      <ModalBody>
        <Label>Select Service Provider</Label>
        <Select
          components={{ Input: CustomSelectInput }}
          className="react-select"
          classNamePrefix="react-select"
          name="form-field-name"
          options={providerOptions}
          isLoading={spOptions.loading}
          formatOptionLabel={formatEligibilityOption}
          value={provider}
          onChange={val => {
            if (provider?.key !== val?.key) {
              newOrder.sp_id = val.key
              newOrder.sp_name = val.name
              newOrder.sp_name_ar = val.name_ar
              delete newOrder.addons
              delete newOrder.price.addonsPrice
              // back to the original's discounts; the price effect re-decides them for a new provider
              applyCarriedDiscounts(newOrder.price, { fields: pickDiscountFields(selectedBooking?.price) })
              delete newOrder.price.variPrice
              delete newOrder.price.variationPrice
              delete newOrder.price.warrantyPrice
              delete newOrder.price.pickupOnlyPrice
              delete newOrder.price.pickupAndDropoffPrice
              delete newOrder.superAdminComment
              delete newOrder.variation
              setAddons({})
              setNewOrder(newOrder)
              setProvider(val)
              setFilteredWashers(Object.values(washers).filter(rec => rec?.sp_id === val?.key))
              setWasher(false)
              setStatus('new')

              setOrderDate(false)

              // reassigning: preselect the provider's best worker and its free time
              const bestWasher = val.key !== selectedBooking?.sp_id && spOptions.byId?.[val.key]?.bestWorkerId
                && Object.values(washers).find(w => w.key === spOptions.byId[val.key].bestWorkerId)
              if (bestWasher) {
                newOrder.washer_id = bestWasher.key
                newOrder.washer_name = bestWasher.name
                setWasher(bestWasher)
                applyWorkerSlot(val.key, bestWasher.key)
              }
            }
          }}
        />
        {spOptions.byId ? <CustomInput
          type="checkbox"
          id="manage-order-show-all-providers"
          className="mt-1"
          checked={showAllProviders}
          onChange={() => setShowAllProviders(!showAllProviders)}
          label={<small>Show all providers and workers (ones that can't take this order are greyed out with the reason)</small>}
        /> : spOptions.loading ? <small className="text-muted d-block mt-1">Checking which providers can take this order…</small>
          : spOptions.error ? <small className="d-block mt-1" style={{ color: '#b45309' }}>Couldn't check which providers can take this order — showing all providers.</small> : null}
        <Label className="mt-2">Select Worker</Label>
        <Select
          components={{ Input: CustomSelectInput }}
          className="react-select"
          classNamePrefix="react-select"
          name="form-field-name"
          options={workerOptions}
          formatOptionLabel={formatEligibilityOption}
          value={washer}
          onChange={val => {
            if (washer?.key !== val?.key) {
              newOrder.washer_id = val.key
              newOrder.washer_name = val.name
              if (provider?.key !== selectedBooking?.sp_id) applyWorkerSlot(provider?.key, val.key)

              setNewOrder(newOrder)
              setWasher(val)
            }
          }}
        />

        <Label className="mt-2">Select Date</Label>
        <DatePicker
          popperClassName="redatepicker"
          customInput={<DatepickerInput />}
          selected={(moment(orderDate || new Date()).toDate())}

          onChange={date => {
            setOrderDate(date)
            newOrder.bookingDate = moment(date).valueOf()
            newOrder.bookingTime.startTime = moment("1955-01-05T" + moment(date).format('HH:mm')).valueOf()
            newOrder.bookingTime.endTime = moment(newOrder.bookingTime.startTime).add(duration, 'minutes').add(30, 'minutes').valueOf()
            setNewOrder(newOrder)
          }}
          excludeTimes={washer && _getReservedSlot(washer).map(rec => {
            return (moment(orderDate || new Date()).toDate().getDate() === moment(rec.reservedSlot).toDate().getDate()) && rec.reservedSlot
          })}
          includeTimes={_filterPassedTime().map(rec => {
            return rec
          })}
          showTimeSelect
          timeFormat="hh:mm a"
          timeIntervals={15}
          timeCaption="time"
          dateFormat="dd/MM/yyyy hh:mm a"
        />

        <Label className="mt-2">Select Status</Label>
        <Select
          components={{ Input: CustomSelectInput }}
          className="react-select"
          classNamePrefix="react-select"
          name="form-field-name"
          options={statusOptions}
          value={statusOptions.find(rec => rec.key === status)}
          onChange={val => {
            if (status !== val.key) {
              newOrder.status = val.key

              newOrder.canceledBy = (val.key === 'canceled' || val.key === "rejected") ? (user?.displayName + ` (${accessTypesObject?.[user?.accessType].name})`) : ''

              setNewOrder(newOrder)
              setStatus(val.key)
            }
          }}
        />
        {['canceled', 'rejected'].includes(newOrder.status) ?
          <>
            <Label className="mt-2">Cancel / Reject Reason</Label>
            <Select
              components={{ Input: CustomSelectInput }}
              className="react-select"
              classNamePrefix="react-select"
              name="form-field-name"
              options={cancelReasons?.map(rec => ({ key: rec, label: rec, value: rec })) || []}
              value={cancelReasons?.map(rec => ({ key: rec, label: rec, value: rec }))?.find(rec => rec.key === newOrder?.cancelReason) || { key: 'Other', label: 'Other', value: 'Other' }}
              onChange={val => {
                if (val.key === 'Other') {
                  setNewOrder({ ...newOrder, cancelReason: '' })
                } else {
                  setNewOrder({ ...newOrder, cancelReason: val.key })
                }
              }}
            />
            {!cancelReasons.includes(newOrder?.cancelReason) || newOrder?.cancelReason === 'Other' ?
              <>
                <Label className="mt-2">Type the reason for cancelation <span style={{ color: '#dc3545' }}>*</span></Label>
                <textarea
                  className="form-control"
                  placeholder='Other - Please provide details.'
                  value={newOrder?.cancelReason || ''}
                  required={['canceled', 'rejected'].includes(newOrder?.status)}
                  style={{ borderColor: !newOrder?.cancelReason || newOrder?.cancelReason.trim() === '' ? '#dc3545' : '' }}
                  onChange={(e) => {
                    setNewOrder({ ...newOrder, cancelReason: e.target.value })
                  }}
                />
              </> : ''}
          </>
          : ''}
        {['canceled', 'rejected'].includes(newOrder.status) ?
          <CustomInput
            className="custom-checkbox mb-0 mt-2 d-inline-block"
            type="checkbox"
            id="checkAll"
            checked={newOrder.cancellationApplied}
            onChange={(e) => {
              setNewOrder({ ...newOrder, cancellationApplied: e.target.checked })
            }}
            label={<div style={{ cursor: 'pointer', fontWeight: '700' }}>Apply Cancellation Fees</div>}
          />
          : ''}
        {newOrder.paymentType === 'cash' ?
          <>
            <div className="mt-3" style={{
              padding: '14px 16px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              border: '1px solid #e9ecef',
              transition: 'all 0.2s ease'
            }}>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <Switch
                    className="custom-switch custom-switch-primary"
                    checked={!newOrder.isUnpaid}
                    onChange={(switchChecked) => {
                      setNewOrder({ ...newOrder, isUnpaid: !switchChecked })
                    }}
                  />
                  <Label
                    className="mb-0 ml-3"
                    style={{
                      fontWeight: '600',
                      cursor: 'pointer',
                      fontSize: '15px',
                      color: '#495057',
                      marginBottom: 0,
                      userSelect: 'none'
                    }}
                    onClick={() => {
                      setNewOrder({ ...newOrder, isUnpaid: !newOrder.isUnpaid })
                    }}
                  >
                    {!newOrder.isUnpaid ? (
                      <span style={{ color: '#28a745', display: 'flex', alignItems: 'center' }}>
                        Order is paid
                      </span>
                    ) : (
                      <span style={{ color: '#dc3545', display: 'flex', alignItems: 'center' }}>
                        Order is unpaid
                      </span>
                    )}
                  </Label>
                </div>
                {!newOrder.isUnpaid && (
                  <span
                    style={{
                      fontSize: '12px',
                      color: '#155724',
                      backgroundColor: '#d4edda',
                      padding: '4px 10px',
                      borderRadius: '12px',
                      fontWeight: '600',
                      border: '1px solid #c3e6cb'
                    }}
                  >
                    Paid
                  </span>
                )}
              </div>
              <div className="mt-2" style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #e9ecef' }}>
                <p style={{
                  margin: 0,
                  fontSize: '13px',
                  color: '#6c757d',
                  lineHeight: '1.5'
                }}>
                  <strong style={{ color: '#495057' }}>Note:</strong> You can update the appointment paid status if the appointment is marked as pending or unpaid by mistake from the worker.
                </p>
              </div>
            </div>
          </> : ''}



        <AddCar addCar={addCar} submit={(e) => {
          let cars = JSON.parse(JSON.stringify(car)) || []
          cars.push(e)
          UpdateCars(cars)
          setAddCar(false)
        }} dismiss={() => setAddCar(false)} />
        {(newOrder?.variation ? true : price && price !== 0) ?
          <div>
            <div className="mt-4 mb-2 d-flex align-items-center" style={{ justifyContent: 'space-between' }}>
              <h5 >Details</h5>
              {/* {!newOrder?.subscription && <Button size='sm' color="primary" onClick={() => {
                setAddCar(true)
              }} >
                Add Car
              </Button>} */}
            </div>
            <DetailsTable
              modifiers={modifiers}
              carDetail={car}
              selectedBooking={newOrder}
              washer={washer}
              service={service.key}
              price={newOrder?.price}
              addonsOptimized={addonsOptimized}
              manageOrder={true}
              removeCar={(carModel) => {
                let cars = (JSON.parse(JSON.stringify(car)) || []).filter(c => (c?.car_model + " " + c?.modelNumber?.model) !== carModel)
                if (newOrder?.addons?.length) {
                  let addons = removeCar(newOrder?.addons, carModel)
                  setNewOrder({ ...newOrder, addons })
                }

                UpdateCars(cars)
              }}
              onlinePayment={onlinePayment}
              setOnlinePayment={(e) => {
                setOnlinePayment(e)
              }} />



            {/* <Row>
              <Colxx xxs="12" >
                {car?.map((rec, index) => {
                  let category = rec?.modelNumber?.category
                  let carModel = rec?.car_model + " " + rec?.modelNumber?.model


                  let id = Object.values(modifiers).find(record => record?.name === category)?.key
                  let servicePrice = ((washer?.activeServices?.[service?.key]?.[id]?.price * 1) || 0) + (newOrder.price?.variPrice?.[id] || 0)
                  let Variations = { darkness: 'Tint Level', frontSide: 'Selected Sides', brand: 'Package', heatRejection: 'Heat Rejection' }

                  return (
                    <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ flex: '2' }}>
                        <div className="mt-2 mb-1" style={{ fontWeight: '700' }}>{carModel + " - " + category}</div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginLeft: '12px' }}>
                          <div><span style={{ fontWeight: '600' }}>{"1x "}</span> {newOrder.service_name}</div>
                          <div style={{ fontWeight: '700' }}>{servicePrice} AED</div>

                        </div>
                        {newOrder?.variation && Object.keys(newOrder?.variation).length &&
                          Object.keys(newOrder?.variation).map((variation, index) => {
                            return (
                              <div className="mb-1" key={index} style={{ marginLeft: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '12px', paddingLeft: '19px' }}>
                                <div >{Variations?.[variation]}: </div>
                                <div >{newOrder?.variation[variation]}</div>
                              </div>
                            )
                          })
                        }
                        {addonsOptimized?.[carModel] && Object.values(addonsOptimized[carModel]).map((addon, index) => {
                          return (
                            <div key={index} style={{ marginLeft: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <div ><span style={{ fontWeight: '600' }}>{addon.count + "x "}</span> {addon.name} </div>
                              <div style={{ fontWeight: '700' }}>{Number(addon.count) * Number(addon.price)} AED</div>
                            </div>
                          )
                        })
                        }
                      </div>
                      {(car.length > 1 && newOrder?.paymentType === 'cash' && !['completed', 'rated', 'canceled', 'rejected'].includes(selectedBooking?.status)) ?
                        <i className="simple-icon-trash ml-2 mt-2"
                          style={{ cursor: 'pointer', flex: '0.2', fontSize: '16px', textAlign: 'end', color: '#dc3545' }}
                          onClick={() => {

                            let cars = (JSON.parse(JSON.stringify(car)) || []).filter(c => (c?.car_model + " " + c?.modelNumber?.model) !== carModel)
                            if (newOrder?.addons?.length) {
                              let addons = removeCar(newOrder?.addons, carModel)
                              setNewOrder({ ...newOrder, addons })
                            }

                            UpdateCars(cars)
                          }} /> : ''}
                    </div>
                  )
                })
                }
              </Colxx>
            </Row>


            {newOrder.price?.code && newOrder?.price?.discount && <Row>
              <Colxx xxs="12" className="mt-3" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                <div style={{ flex: '2', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ fontWeight: '700' }}>Discount:</div>
                  <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                    {newOrder.price?.code === 'loyalty' ? <div >Loyalty points</div>
                      : newOrder.price?.code === 'wallet' ? <div >Wallet</div>
                        : newOrder.price?.code === 'voucher' ? <div >Voucher</div>
                          : newOrder.price?.code === 'bogo' ? <div >BOGO</div>
                            : <div >Promo Code: {newOrder.price?.code}</div>}

                    <div style={{ fontWeight: '700' }}>{newOrder.price?.discount} AED</div>
                  </div>
                </div>
                {(car.length > 1 && newOrder?.paymentType === 'cash' && !['completed', 'rated', 'canceled', 'rejected'].includes(selectedBooking?.status)) ? <div className="ml-2 mt-2"
                  style={{ flex: '0.2' }}
                  onClick={() => {
                  }} /> : ''}
              </Colxx>
            </Row>

            }

            {newOrder?.price?.outstanding ? <Row>
              <Colxx xxs="12" className="mt-3" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                <div style={{ flex: '2', }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ fontWeight: '700' }}>Outstanding Amount:</div>
                    <div style={{ fontWeight: '700' }}>{newOrder.price.outstanding} AED</div>
                  </div>
                  {newOrder.price.outstanding > 0 ? <CustomInput
                    className="custom-checkbox d-inline-block"
                    type="checkbox"
                    id="checkAll"
                    checked={onlinePayment}
                    onChange={(e) => {
                      setOnlinePayment(e.target.checked)
                    }}
                    label={<div style={{ cursor: 'pointer' }}>Outstanding amount will be collected online </div>}
                  /> : ''}
                </div>
                {(car.length > 1 && newOrder?.paymentType === 'cash' && !['completed', 'rated', 'canceled', 'rejected'].includes(selectedBooking?.status)) ? <div className="ml-2 mt-2"
                  style={{ flex: '0.2' }}
                  onClick={() => {
                  }} /> : ''}
              </Colxx>
            </Row> : ''}
            <Row>
              <Colxx xxs="12" className="mt-3" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                <div style={{ flex: '2', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ fontWeight: '700' }}>Total Price:</div>
                  <div style={{ fontWeight: '700' }}>{newOrder.price.totalPrice} AED</div>
                </div>
                {(car.length > 1 && newOrder?.paymentType === 'cash' && !['completed', 'rated', 'canceled', 'rejected'].includes(selectedBooking?.status)) ? <div className="ml-2 mt-2"
                  style={{ flex: '0.2' }}
                  onClick={() => {
                  }} /> : ''}
              </Colxx>
            </Row> */}
          </div> : ''
        }
      </ModalBody>
      <ModalFooter>
        <Button color="danger" outline onClick={() => {
          setWasher(false)
          setProvider({})
          setStatus(false)
          setFilteredWashers([])

          dismiss()
        }}>
          Dismiss
        </Button>
        <Button
          disabled={(newOrder?.variation ? false : price === 0)}
          color="primary" outline onClick={() => {
            if (provider && washer && orderDate && status) {
              // Validate cancel reason is required for canceled/rejected status
              if (['canceled', 'rejected'].includes(status)) {
                // Check if a predefined reason is selected
                const hasPredefinedReason = cancelReasons.includes(newOrder?.cancelReason);
                // Check if custom reason is provided (when Other is selected or custom text is entered)
                const hasCustomReason = newOrder?.cancelReason && newOrder?.cancelReason.trim() !== '';

                if (!hasPredefinedReason && !hasCustomReason) {
                  return createNotification("error", "Please provide a reason for cancellation/rejection")
                }
              }
              setConfirmUpdate(true)
            } else {
              if (!provider) {
                return createNotification("error", "Kindly select service provider")
              }
              if (!washer) {
                return createNotification("error", "Kindly select worker")

              }
              if (!orderDate) {
                return createNotification("error", "Kindly select order date")

              }
              if (!status) {
                return createNotification("error", "Kindly select status")
              }
            }
          }} >
          Confirm
        </Button>{" "}
      </ModalFooter>
      <Modal
        backdrop="static"
        isOpen={confirmUpdate}>
        <ModalHeader>Confirm Update</ModalHeader>
        <ModalBody>
          {status === 'completed' && selectedBooking?.status !== 'completed' && selectedBooking?.recoveryInfo ? (
            <div>
              {towingAssignment.sp_id || towingAssignment.washer_id ? (
                <p className="mb-2 p-2" style={{ background: '#f5f9ff', borderRadius: 6 }}>
                  This order moves to{towingAssignment.sp_id ? <> provider <strong>{provider?.name}</strong></> : null}
                  {towingAssignment.sp_id && towingAssignment.washer_id ? ',' : null}
                  {towingAssignment.washer_id ? <> worker <strong>{washer?.name}</strong></> : null} before it is completed.
                </p>
              ) : null}
              <p><strong>You are about to complete a towing order.</strong> How did the customer pay?</p>
              {[
                { id: 'card', label: "Charge the customer's saved card now", hint: 'The trip price is calculated and charged to the card on the order.' },
                { id: 'paymentLink', label: 'Already paid by payment link', hint: 'Paid through a Network International link. The card is not charged.' },
                { id: 'cash', label: 'Already paid in cash', hint: 'Cash collected by the provider. The card is not charged.' },
              ].map(opt => (
                <label key={opt.id} className="d-flex align-items-start mb-2" style={{ cursor: 'pointer' }}>
                  <input
                    type="radio" name="recoveryPaidBy" className="mt-1 mr-2"
                    checked={recoveryPaidBy === opt.id}
                    onChange={() => {
                      setRecoveryPaidBy(opt.id)
                      setConfirmChargeCanceled(false)
                      if (opt.id !== 'card' && !recoveryPaidAmount) {
                        const total = Number(selectedBooking?.price?.totalPrice)
                        setRecoveryPaidAmount(Number.isFinite(total) && total > 0 ? String(total) : '')
                      }
                    }}
                  />
                  <span>{opt.label}<br /><small className="text-muted">{opt.hint}</small></span>
                </label>
              ))}
              {recoveryPaidBy === 'card' && recoveryOrderCanceled ? (
                <div className="mt-2 p-2" style={{ background: '#fff4e5', border: '1px solid #f5c26b', borderRadius: 6 }}>
                  <p className="mb-2" style={{ color: '#9a5b00' }}>
                    <strong>This order is {selectedBooking?.status === 'rejected' ? 'rejected' : 'cancelled'}.</strong> If the customer already paid by payment link or cash, charging the card takes the money a second time.
                  </p>
                  <label className="d-flex align-items-start mb-0" style={{ cursor: 'pointer' }}>
                    <input type="checkbox" className="mt-1 mr-2" checked={confirmChargeCanceled} onChange={e => setConfirmChargeCanceled(e.target.checked)} />
                    <span>I confirm the customer has not paid this order any other way (payment link, cash). Charge the card.</span>
                  </label>
                </div>
              ) : null}
              {['paymentLink', 'cash'].includes(recoveryPaidBy) ? (
                <div className="mt-2 p-2" style={{ background: '#f5f9ff', borderRadius: 6 }}>
                  <Label className="mb-1">Amount the customer paid (AED) <span style={{ color: '#dc3545' }}>*</span></Label>
                  <Input type="number" min="0" step="0.01" value={recoveryPaidAmount} onChange={e => setRecoveryPaidAmount(e.target.value)} />
                  {recoveryPaidBy === 'paymentLink' ? (
                    <>
                      <Label className="mb-1 mt-2">Payment reference (optional)</Label>
                      <Input type="text" placeholder="Network International order reference" value={recoveryPaidRef} onChange={e => setRecoveryPaidRef(e.target.value)} />
                    </>
                  ) : null}
                  <small className="d-block mt-2 text-muted">The order is completed with this amount as its total, and the VAT invoice is issued for it.</small>
                </div>
              ) : null}
            </div>
          ) : (
            "Are you sure you want to apply changes to this appointment?"
          )}
          {(() => {
            const isReassignment = !completingTowing && selectedBooking?.sp_id && provider?.key && selectedBooking.sp_id !== provider.key
            const { carried = [], dropped = [] } = carriedDiscounts || {}
            if (!isReassignment || (!carried.length && !dropped.length)) return null
            return (
              <div className="mt-3 p-2" style={{ background: '#f5f9ff', borderRadius: 6 }}>
                {carried.length ? <small className="d-block">Discounts carried to the new booking: {carried.map(d => `${DISCOUNT_LABELS[d.kind] || d.kind} ${Number(d.amount).toFixed(2)} AED`).join(', ')}.</small> : null}
                {dropped.length ? <small className="d-block mt-1" style={{ color: '#b45309' }}>Not carried: {dropped.map(d => `${DISCOUNT_LABELS[d.kind] || d.kind}${Number(d.amount) > 0 ? ` ${Number(d.amount).toFixed(2)} AED` : ''} (${DROP_REASONS[d.reason] || d.reason})`).join(', ')}.</small> : null}
              </div>
            )
          })()}
          {(() => {
            const isReassignment = !completingTowing && selectedBooking?.sp_id && provider?.key && selectedBooking.sp_id !== provider.key
            const { isOriginalOnlinePaid, cardCaptured, previousWaived, effectiveDelta } = reassignmentMath
            if (!isReassignment || !isOriginalOnlinePaid) return null
            if (Math.abs(effectiveDelta) < 0.01) {
              return (
                <div className="mt-3 p-2" style={{ background: '#f5f9ff', borderRadius: 6 }}>
                  <small>The original card payment ({cardCaptured.toFixed(2)} AED){previousWaived > 0 ? ` and previously-waived amount (${previousWaived.toFixed(2)} AED)` : ''} will carry over to the new booking. No refund to wallet.</small>
                </div>
              )
            }
            if (effectiveDelta < 0) {
              return (
                <div className="mt-3 p-2" style={{ background: '#f5f9ff', borderRadius: 6 }}>
                  <small>{cardCaptured.toFixed(2)} AED on card carries over.{previousWaived > 0 ? ` Previously waived ${previousWaived.toFixed(2)} AED carries over.` : ''} {Math.abs(effectiveDelta).toFixed(2)} AED will be credited to the customer wallet as a partial refund.</small>
                </div>
              )
            }
            return (
              <div className="mt-3 p-3" style={{ background: '#fff8e6', borderRadius: 6 }}>
                <p className="mb-2"><strong>New service costs {effectiveDelta.toFixed(2)} AED more than what the customer has already committed.</strong></p>
                {previousWaived > 0 ? <p className="mb-2"><small>(Card: {cardCaptured.toFixed(2)} AED + previously waived: {previousWaived.toFixed(2)} AED already covered.)</small></p> : null}
                <p className="mb-2">How should the difference be handled?</p>
                <CustomInput
                  type="radio"
                  id="reassign-choice-cash"
                  name="reassign-choice"
                  checked={reassignmentChoice === 'cash'}
                  onChange={() => setReassignmentChoice('cash')}
                  label={`Collect ${effectiveDelta.toFixed(2)} AED cash from customer on completion`}
                />
                <CustomInput
                  type="radio"
                  id="reassign-choice-waive"
                  name="reassign-choice"
                  checked={reassignmentChoice === 'waive'}
                  onChange={() => setReassignmentChoice('waive')}
                  label={`Waive the extra ${effectiveDelta.toFixed(2)} AED`}
                />
              </div>
            )
          })()}
        </ModalBody>
        <ModalFooter>
          <Button color="danger" outline onClick={() => {
            setConfirmUpdate(false)
            setReassignmentChoice(null)
            setRecoveryPaidBy(null)
            setConfirmChargeCanceled(false)
          }} disabled={isUpdating}>
            Cancel
          </Button>
          <Button
            disabled={(() => {
              if ((newOrder?.variation ? false : price === 0) || isUpdating) return true
              if (status === 'completed' && selectedBooking?.status !== 'completed' && selectedBooking?.recoveryInfo) {
                if (!recoveryPaidBy) return true
                if (recoveryPaidBy === 'card' && recoveryOrderCanceled && !confirmChargeCanceled) return true
                if (recoveryPaidBy !== 'card' && !(Number(recoveryPaidAmount) > 0)) return true
              }
              const isReassignment = !completingTowing && selectedBooking?.sp_id && provider?.key && selectedBooking.sp_id !== provider.key
              if (isReassignment && !discountContext) return true // still loading the original's discounts
              const { isOriginalOnlinePaid, effectiveDelta } = reassignmentMath
              return isReassignment && isOriginalOnlinePaid && effectiveDelta > 0 && !reassignmentChoice
            })()}
            color="primary" outline onClick={() => {
              updateOrder()
            }} >
            {isUpdating ? (
              <>
                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                {status === 'completed' && selectedBooking?.status !== 'completed' && selectedBooking?.recoveryInfo ? 'Completing...' : 'Updating...'}
              </>
            ) : (
              status === 'completed' && selectedBooking?.status !== 'completed' && selectedBooking?.recoveryInfo ? 'Complete Recovery Order' : 'Confirm Update'
            )}
          </Button>{" "}
        </ModalFooter>
      </Modal>

      <Modal
        backdrop="static"
        isOpen={recoveryErrorModal}>
        <ModalHeader>
          <div style={{ color: '#dc3545', fontWeight: 'bold' }}>Recovery Order Error</div>
        </ModalHeader>
        <ModalBody>
          <div>
            <p><strong>Error:</strong> {recoveryErrorMessage}</p>
            <p>The recovery order completion failed. You can either:</p>
            <ul>
              <li><strong>Complete as Cash:</strong> Complete the order with cash payment</li>
              <li><strong>Share Link:</strong> Close this dialog and share payment link with customer</li>
            </ul>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => {
            setRecoveryErrorModal(false)
            setRecoveryErrorMessage('')
          }} disabled={isCompletingCash}>
            Share Link
          </Button>
          <Button
            disabled={isCompletingCash}
            color="success" outline onClick={() => {
              completeOrderAsCash()
            }} >
            {isCompletingCash ? (
              <>
                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                Completing...
              </>
            ) : (
              'Complete as Cash'
            )}
          </Button>{" "}
        </ModalFooter>
      </Modal>
    </Modal>
  );
};

export default ManageOrder;